<template>
  <article class="post--product post--card product-selector__card">
    <a :href="productGroup.pageUrl + productGroup.filteredProductIds">
      <figure>
        <div class="post__details">
          <h4 class="post__title">{{ productGroup.name }}</h4>
        </div>
        <picture>
          <img :src="productGroup.imageUrl" />
        </picture>
      </figure>
    </a>
  </article>
</template>

<script>
export default {
  props: ['productGroup']
}
</script>
